module.exports = __webpack_public_path__ + "static/expensesTracker-22925ca62e15c002c12abf0c7cbf8dce.png";